import React from "react";
import {useAuth0} from "@auth0/auth0-react";

function LogoutButton()
{
	const {logout} = useAuth0();

	return (
		<button type="button" className="btn btn-accent w-full mt-2"
		        onClick={() => logout()}>Logout</button>
	);
}

export default LogoutButton;
